import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/app/components/ui/utils';

type PrimitiveProps = HTMLAttributes<HTMLElement> & {
  children: ReactNode;
};

export function DSPage({ children, className, ...props }: PrimitiveProps) {
  return (
    <div className={cn('ds-page', className)} {...props}>
      {children}
    </div>
  );
}

export function DSPageSection({ children, className, ...props }: PrimitiveProps) {
  return (
    <section className={cn('ds-page-section', className)} {...props}>
      {children}
    </section>
  );
}

export function DSSurface({ children, className, ...props }: PrimitiveProps) {
  return (
    <section className={cn('ds-surface', className)} {...props}>
      {children}
    </section>
  );
}

export function DSState({ children, className, state = 'empty', ...props }: PrimitiveProps & { state?: 'loading' | 'empty' | 'error' }) {
  const stateClass =
    state === 'loading' ? 'ds-state-loading' : state === 'error' ? 'ds-state-error' : 'ds-state-empty';
  return (
    <section className={cn(stateClass, className)} {...props}>
      {children}
    </section>
  );
}

export function DSStack({
  children,
  className,
  size = 16,
  ...props
}: PrimitiveProps & { size?: 8 | 16 | 24 | 32 }) {
  return (
    <div className={cn(`ds-stack-${size}`, className)} {...props}>
      {children}
    </div>
  );
}
